import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import en from './locales/en.json';
import es from './locales/es.json';

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: { translation: en },
      es: { translation: es }
    },
    fallbackLng: 'en',
    supportedLngs: ['en', 'es'],
    interpolation: {
      escapeValue: false
    },
    detection: {
      // Use a new key to invalidate older localStorage values (forces EN default after 2026-02-12)
      lookupLocalStorage: 'bw_i18n_v2',
      order: ['localStorage', 'htmlTag'],
      caches: ['localStorage']
    }
  });

export default i18n;
